module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/userPrivacy-slot.2586709b.png";